"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Icon = require("../js/Icon");

var _Icon2 = _interopRequireDefault(_Icon);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WrappedIcon = function WrappedIcon(props) {
  return _react2.default.createElement(
    _Icon2.default,
    props,
    _react2.default.createElement(
      "svg",
      { className: "spectrum-UIIcon-StarOutline" },
      _react2.default.createElement("path", { d: "M9.031 2.541l1.777 4.753 5.11.241-3.987 3.2 1.336 4.913L9 12.866l-4.281 2.808 1.352-4.937-3.987-3.2 5.1-.245zM9.042.412a.369.369 0 0 0-.349.239L6.486 6.326l-6.1.293a.375.375 0 0 0-.217.667l4.762 3.821L3.318 17a.376.376 0 0 0 .264.462.406.406 0 0 0 .1.013.367.367 0 0 0 .2-.063L9 14.061l5.1 3.324a.371.371 0 0 0 .576-.314.369.369 0 0 0-.013-.1l-1.6-5.866 4.768-3.825a.375.375 0 0 0-.217-.667l-6.1-.287L9.393.655a.369.369 0 0 0-.351-.243z", className: "spectrum-UIIcon--medium" }),
      _react2.default.createElement("path", { d: "M11 4.9l1.231 3.255A1.777 1.777 0 0 0 13.809 9.3l3.476.165-2.715 2.18a1.777 1.777 0 0 0-.6 1.855l.918 3.357-2.909-1.91a1.777 1.777 0 0 0-1.951 0l-2.909 1.91.914-3.357a1.779 1.779 0 0 0-.6-1.856L4.715 9.469 8.191 9.3a1.777 1.777 0 0 0 1.578-1.142zm0-3.458a.449.449 0 0 0-.426.294L8.35 7.621a.26.26 0 0 1-.231.168l-6.282.3a.456.456 0 0 0-.434.476.461.461 0 0 0 .171.334l4.907 3.933a.26.26 0 0 1 .088.271l-1.657 6.064a.457.457 0 0 0 .321.561.438.438 0 0 0 .119.016.45.45 0 0 0 .249-.076l5.257-3.452a.259.259 0 0 1 .285 0l5.257 3.451a.45.45 0 0 0 .249.076.458.458 0 0 0 .456-.458.438.438 0 0 0-.016-.119L15.43 13.1a.26.26 0 0 1 .088-.271L20.426 8.9a.455.455 0 0 0-.263-.81l-6.282-.3a.26.26 0 0 1-.231-.168l-2.224-5.883A.449.449 0 0 0 11 1.445z", className: "spectrum-UIIcon--large" })
    )
  );
};

WrappedIcon.displayName = 'StarOutline';
exports.default = WrappedIcon;

